import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import WorkFlowTaskListServices from "./workflowTaskList.services";
import toastr from "toastr";
import { enviarCorreo } from "../capacitacion/actions";

export const getWorkFlowTasksList = (filters, type) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_WORKFLOWBLOCK_TASKS_LISTS,
      payload: true,
    });
    const resp = await WorkFlowTaskListServices.getWorkFlowTasksList(
      filters,
      type
    );

    dispatch({
      type: actions.GET_WORKFLOWBLOCK_TASKS_LIST,
      payload: resp.data,
      // {
      //   workflowBlockCheckLists: resp.data.data,
      //   workflowBlockCheckListsLength: resp.data.count,
      // },
    });

    // if (setData) {
    //   setData(resp.data.data);
    // }

    dispatch({
      type: actions.WORKFLOWBLOCK_TASK_LIST_FAIL,
      payload: "",
    });
    dispatch({
      type: actions.WORKFLOWBLOCK_TASK_LIST_FORM_FAIL,
      payload: null,
    });
  } catch (ex) {
    let message = "";
    if (axios.isAxiosError(ex)) {
      if (ex.response?.data) {
        message = ex.response.data.message;
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.WORKFLOWBLOCK_TASK_LIST_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_WORKFLOWBLOCK_TASKS_LISTS,
      payload: false,
    });
  }
};

export const estadoActividad = (req, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_WORKFLOWBLOCK_TASK_LIST,
      payload: true,
    });
    await WorkFlowTaskListServices.estadoActividad(req);
    const { data, count } = getState().workflowTaskList.workflowTasksList;
    data[index].estado = true;
    dispatch({
      type: actions.GET_WORKFLOWBLOCK_TASKS_LIST,
      payload: { data: data, count: count },
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            toastr.info("La tarea no puede ser actualizada");
            message = ex.response.data;
            break;
          case 500:
            message = messages.errorMessage + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.WORKFLOWBLOCK_TASK_LIST_FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_WORKFLOWBLOCK_TASK_LIST,
      payload: false,
    });
  }
};

export const editWorkFlowTaskList =
  (req, id, workflow_id, bloque_id, tarea_id, sameComp) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_WORKFLOWBLOCK_TASK_LIST,
        payload: true,
      });
      const resp = await WorkFlowTaskListServices.editWorkFlowTaskList(
        id,
        req
        // type
      );

      await WorkFlowTaskListServices.dateManageWorkFlow({
        tarea: id,
      });

      // let oWorkflowBlockCheckLists = {
      //   workflowBlockCheckLists: [],
      //   workflowBlockCheckListsLength: 0,
      // };

      const { data, count } = getState().workflowTaskList.workflowTasksList;
      const ind = data.findIndex((item) => item.id === id);
      data[ind] = resp.data;
      dispatch({
        type: actions.GET_WORKFLOWBLOCK_TASKS_LIST,
        payload: { data: data, count: count },
      });
      dispatch({
        type: actions.WORKFLOWBLOCK_TASK_LIST_FORM_FAIL,
        payload: null,
      });
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = ex.response.data;
              break;
            case 500:
              message = messages.errorMessage + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.WORKFLOWBLOCK_TASK_LIST_FORM_FAIL,
        payload: message,
      });
    } finally {
      if (sameComp === false) {
        dispatch(
          enviarCorreo({
            workflow_id: workflow_id,
            bloque_id: bloque_id,
            tarea_id: tarea_id,
            tipo_mensaje: "Companero Guia - Notificacion acompanamiento",
          })
        );
      }
      dispatch({
        type: actions.SAVE_LOADING_WORKFLOWBLOCK_TASK_LIST,
        payload: false,
      });
    }
  };
